import { HttpErrorResponse } from "@angular/common/http";
import { Centre, CentreListDTO } from "src/app/_models/Centre";

export interface CentreState {
    loading: boolean;
    list: Centre[];
    error: any;

    validCentre: boolean | null;
    proceedStep: boolean;

    crudData: CentreListDTO;
    crudDataLoader: boolean;
    crudCentreLoader: boolean;
    crudResult: Centre | null;
    crudError: any;

    centreRecords: CentreListDTO[];
    centreRecordsLength: number;

    isInitialLoadFlowReset: boolean;
    isGetTableOverallLength: boolean;
    deleteCentreLoader: boolean;
    isDeleteCentre: boolean;
    isValidDeleteCentre: boolean;
    
    deleteCentreError: any;
    validateDeleteCentreError: any;
    centreList: Centre[];

    orgCentreList: Centre[];
    orgCentreListLoader: boolean;
    orgCentreListError: HttpErrorResponse;
}

export const initialCentreState: CentreState = {
    loading: false,
    list: [],
    error: null,

    validCentre: null,
    proceedStep: false,

    crudData: null,
    crudDataLoader: false,
    crudCentreLoader: false,
    crudResult: null,
    crudError: null,

    centreRecords: [],
    centreRecordsLength: 0,

    isInitialLoadFlowReset: false,
    isGetTableOverallLength: false,
    deleteCentreLoader: false,
    isDeleteCentre: false,
    isValidDeleteCentre: false,

    deleteCentreError: null,
    validateDeleteCentreError: null,
    centreList: [],

    orgCentreList: null,
    orgCentreListLoader: false,
    orgCentreListError: null
}